var chunkMapping = {
	"6179": [
		62797,
		75228,
		88296,
		93947
	],
	"7126": [
		4446,
		17418,
		49394,
		85646
	],
	"7293": [
		7293
	],
	"8165": [
		29870,
		31930,
		47538,
		51113,
		82893,
		89982
	]
};
var idToExternalAndNameMapping = {
	"4446": [
		"default",
		"./utils/common",
		60174
	],
	"7293": [
		"default",
		"./AppLoader",
		60174
	],
	"17418": [
		"default",
		"./appSlice",
		60174
	],
	"29870": [
		"default",
		"./helpers/PageTitle",
		60174
	],
	"31930": [
		"default",
		"./components/CustomNoDataOverlay",
		60174
	],
	"47538": [
		"default",
		"./helpers/CustomModalStyle",
		60174
	],
	"49394": [
		"default",
		"./store",
		60174
	],
	"51113": [
		"default",
		"./helpers/PageContainer",
		60174
	],
	"62797": [
		"default",
		"./components/ColumnSelectorStyle",
		60174
	],
	"75228": [
		"default",
		"./utils/constants",
		60174
	],
	"82893": [
		"default",
		"./helpers/PageSubHeader",
		60174
	],
	"85646": [
		"default",
		"./headerSlice",
		60174
	],
	"88296": [
		"default",
		"./helpers/CustomSearch",
		60174
	],
	"89982": [
		"default",
		"./helpers/Breadcrumb",
		60174
	],
	"93947": [
		"default",
		"./helpers/CustomDropDownSelect",
		60174
	]
};
var idToRemoteMap = {
	"4446": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 60174
		}
	],
	"7293": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 60174
		}
	],
	"17418": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 60174
		}
	],
	"29870": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 60174
		}
	],
	"31930": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 60174
		}
	],
	"47538": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 60174
		}
	],
	"49394": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 60174
		}
	],
	"51113": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 60174
		}
	],
	"62797": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 60174
		}
	],
	"75228": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 60174
		}
	],
	"82893": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 60174
		}
	],
	"85646": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 60174
		}
	],
	"88296": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 60174
		}
	],
	"89982": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 60174
		}
	],
	"93947": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 60174
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}